<template>
    <div class="normal-section renderer-section">

        <div v-if="index > 0" class="html2pdf__page-break"></div>

        <div class="headline-block section-headline" v-show="section.isShowHeadline">
            <h2 :class="['section-title', section.headlineAdditionalClass]" v-text="localizedSectionHeadline"></h2>
            <p v-if="localizedSectionSubHeadline" :class="['section-subtitle', section.subHeadlineAdditionalClass]" v-text="localizedSectionSubHeadline"></p>
        </div>

        <div :class="[containerClasses, 'section-controls']">
            <ControlView
                v-for="controlId in filteredControls"
                :key="controlId"
                :control="controls[controlId]"
                :parent-id="section.uniqueId"
                :value-container="valueContainer"
                :validation-errors="validationErrors"
                :read-only="readOnly"
                :viewSubmissionMode="viewSubmissionMode"
                :siteID="siteID"
                :patNum=patNum
                :logoUrl="logoUrl"
                :index="index"
                :formSubmissionIDForWeb="formSubmissionIDForWeb"
                :language="language"
            />
        </div>
    </div>
</template>

<script>
    import {RENDERER_SECTION_VIEW_MIXIN} from "../../../mixins/renderer-section-view-mixin";

    /**
     * @property {Object} section
     * @property {Object} rows RowId - RowData
     * @property {Object} controls ControlId - ControlData
     * @property {Array} section.rows
     * @property {Array} section.controls
     */
    export default {
        name: "NormalSectionView",
        mixins: [RENDERER_SECTION_VIEW_MIXIN],
        props: {
            index: Number,
            visibleMap: { type: Object, default: () => ({}) }
        },
        data: () => ({

        }),

        computed: {
            filteredControls() {
                const vm = this
                const controls = vm.controls || {}
                const visibleMap = vm.visibleMap || {}
                return (vm.section.controls || []).filter(controlId => {
                    const control = controls[controlId]
                    // Skip if control doesn't exist (can happen with dynamically copied forms)
                    if (!control) return false
                    const key = control.name ? control.name : control.uniqueId
                    if (!key) return true
                    // default visible when not present in map
                    if (!Object.prototype.hasOwnProperty.call(visibleMap, key)) return true
                    return !!visibleMap[key]
                })
            }
        },

    }
</script>

<style scoped>
/* Renderer-specific section styling */
.renderer-section {
    position: relative;
}

.section-headline {
    position: relative;
}

.section-title {
    position: relative;
    display: inline-block;
}

.section-subtitle {
    margin-top: 4px;
}

.section-controls {
    position: relative;
}
</style>